var map = {
	"./about-modelling.png": "d25a",
	"./about-principles.png": "9e78",
	"./about-processing.png": "75d3",
	"./about-results.png": "628a",
	"./about-site.png": "bbcc",
	"./about-workflow.png": "46ab",
	"./doc.svg": "cc98",
	"./es-frbr-en.svg": "fdce",
	"./es-frbr.svg": "39a0",
	"./es-ont-en.svg": "2363",
	"./es-ont.svg": "432a",
	"./es-rdf-en.svg": "7ed5",
	"./es-rdf.svg": "0254",
	"./kwickk-1.gif": "5ddd",
	"./kwickk-2.gif": "ab21",
	"./kwickk-3.gif": "fcdf",
	"./meta.svg": "e2f7",
	"./site-map.svg": "ad77",
	"./voc-en.svg": "2d3d",
	"./voc.svg": "475f",
	"./wf-contents-example.svg": "53fa",
	"./wf-contents.svg": "6aaf",
	"./wf-documentation-example.svg": "731d",
	"./wf-home.svg": "49a7",
	"./wf-index-example.svg": "00d1",
	"./wf-indexes.svg": "b6c7",
	"./wf-project.svg": "9354",
	"./wf-search.svg": "6818",
	"./wf-work-example-metadata.svg": "9d50",
	"./wf-work-example-text.svg": "7f4c",
	"./wf-works.svg": "4e37",
	"./workflow-en.svg": "93aa",
	"./workflow.svg": "bb71"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5bb0";